import type { CleaningNextArrivalResponse } from '@/shared/api';

export function cleaningOccupancySummary(arrival: CleaningNextArrivalResponse | null): string {
  if (!arrival || arrival.occupancyDataQualityCode === 'NotApplicable') {
    return 'Keine Anreise bekannt';
  }
  if (
    arrival.occupancyDataQualityCode === 'Known' &&
    arrival.guestCount !== null &&
    arrival.adults !== null &&
    arrival.children !== null &&
    arrival.infants !== null
  ) {
    return `${arrival.guestCount} Gäste · ${arrival.adults} Erwachsene · ${arrival.children} Kinder · ${arrival.infants} Kleinkinder`;
  }
  if (arrival.occupancyDataQualityCode === 'Partial' && arrival.guestCount !== null) {
    return `${arrival.guestCount} Gäste · Aufteilung unvollständig`;
  }
  return 'Belegung unbekannt';
}
